const { lazy } = require("react");

export const BlogPage = lazy(() => import('~/screens/blog'));
export const BlogDetailPage = lazy(() => import('~/screens/blog/detail'));
export const BrandPage = lazy(() => import('~/screens/brand'));
export const CareerPage = lazy(() => import('~/screens/career'));
export const ContactPage = lazy(() => import('~/screens/contact'));
export const Homepage = lazy(() => import('~/screens/homepage'));
export const ProfilePage = lazy(() => import('~/screens/profile'));

export const ROUTES = {
    Blog: '/blog',
    BlogDetail: '/blog/:slug',
    Brand: '/brand',
    Career: '/career',
    Contact: '/contact',
    Homepage: '/',
    Profile: '/profile',
};